new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#app_header',
  data: {
    header: {
      useFirst: true, // first headerBar
      myaccount_options: 'dropdown', // 'none' = no dropdowns, 'dropdown' = hover and dropdown menu;
      isNavUp: true,
      isNavDown: true,
      isNavMin: false,
      lastScrollTop: 0,
      menuMobile: false,
      openCategorysMobile: false,
    },
    searchOpened: false,
    cartOpened: false,
  },
  methods: {
    addPaddingHeader() {
      const headerTransparent = document.querySelector('.nav-up');
      const header = document.querySelector('header[data-role="heading"]');
      const headerHeight = header.clientHeight;
      const mainTag = document.querySelector('main[role="main"]');
      const mainDiv = document.querySelector('.main-content');

      if (headerTransparent) {
        if (view_origin != "home") {
          if (mainTag) {
            mainTag.style.paddingTop = `${headerHeight}px`;
          } else {
            mainDiv.style.paddingTop = `${headerHeight}px`;
          }
        }
      } else {
        if (mainTag) {
          mainTag.style.paddingTop = `${headerHeight}px`;
        } else {
          mainDiv.style.paddingTop = `${headerHeight}px`;
        }
      }
    },
    runSpeechRecognition() {
      var isChromium = window.chrome;
      var winNav = window.navigator;
      var vendorName = winNav.vendor;
      var isOpera = typeof window.opr !== "undefined";
      var isIEedge = winNav.userAgent.indexOf("Edge") > -1;
      var isIOSChrome = winNav.userAgent.match("CriOS");

      if (isChromium !== null && typeof isChromium !== "undefined" && vendorName === "Google Inc." && isOpera === false && isIEedge === false) {
        let output = document.querySelector(".output-search");
        let action = document.querySelector(".microphone");
        let inputMic = document.querySelector(".search__text");

        var SpeechRecognition = SpeechRecognition || webkitSpeechRecognition;

        var recognition = new SpeechRecognition();
        recognition.continuous = false;
        recognition.lang = 'pt-BR';


        recognition.onstart = function () {
          if (!output.classList.contains("hide")) {
            output.classList.toggle("hide");
          }

          action.classList.toggle('active');
        };

        recognition.onspeechend = function () {

          action.classList.toggle('active');
          recognition.stop();
        }

        recognition.onresult = function (event) {
          var transcript = event.results[0][0].transcript;
          var confidence = event.results[0][0].confidence * 100;

          if (confidence < 50) {
            inputMic.classList.toggle('not-understand')
            output.classList.toggle("hide");
            inputMic.value = "Desculpe não entendi muito bem.";
          } else {
            inputMic.value = transcript
            document.querySelector('.search__submit').click()
          };

        };

        // start recognition
        recognition.start();
      } else return document.querySelector(".microphone-search").remove();
    },
    scrollFixedMenu() {
      const menuFixed = document.querySelector('.menu-fixed');
      if (menuFixed) {
        let lastScrollTop = 0;
        menuFixed.classList.remove('active');

        window.addEventListener('scroll', function () {
          let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > lastScrollTop) {
            // Scrolling down
            menuFixed.classList.add('active');
          } else {
            // Scrolling up
            menuFixed.classList.remove('active');
          }

          lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For mobile or negative scrolling
        });
      }
    },
    handleScroll() {
      const st = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const scrollDifference = st - this.lastScrollTop;
      const customMobile = document.getElementById('custom-mobile-nav');
      const headerThird = document.getElementById('header-third');
      const quickMenu = document.getElementById('quick-menu-id');
      const whatsappWidget = document.getElementById('widget-whatsapp');

      if (st > this.lastScrollTop)
        this.header.isNavUp = false;
      else {
        if (st === 0)
          this.header.isNavUp = true;
      }

      if (st >= 90 && scrollDifference > 0) {
        this.header.isNavDown = false;
        this.header.isNavMin = true;

        if (customMobile)
          customMobile.classList.add('hide');

        if (headerThird)
          headerThird.classList.add('hide');

        if (quickMenu) {
          quickMenu.classList.add('hide');
          whatsappWidget.style.bottom = '';
        }

      } else {
        this.header.isNavDown = true;
        this.header.isNavMin = false;
        this.header.isNavMenuHide = false;

        if (customMobile)
          customMobile.classList.remove('hide');

        if (headerThird)
          headerThird.classList.remove('hide');

        if (quickMenu) {
          quickMenu.classList.remove('hide');
          whatsappWidget.style.bottom = '79px';
        }
      }

      this.lastScrollTop = st;
    },
    filterItems(item1, item2, item3, item4) {
      var data = [item1, item2, item3, item4];

      for (var i = 0; i < data.length; i++) {
        var element = document.querySelector('[item="' + data[i] + '"]');
        switch (data[i]) {
          case "home":
            element.setAttribute('href', '/');
            break;
          case "menu":
            var newSpan = document.createElement('span');
            newSpan.setAttribute('class', 'quick-menu__item--link toggleMenu js-mobile-nav-trigger');

            while (element.firstChild) {
              newSpan.appendChild(element.firstChild);
            }

            element.parentNode.replaceChild(newSpan, element);
            break;
          case "cart":
            element.setAttribute('href', '/carrinho');
            break;
          case "user":
            element.setAttribute('href', '/clientes/identificacao/?next=/clientes/minha-conta/');
            break;
          case "wishlist":
            element.setAttribute('href', '/clientes/minha-conta/minha-lista-de-produtos/');
            break;
        }
      }
    }
  },
  mounted() {
    $('#js-texto-header').slick({
      arrows: false,
      infinite: false,
      autoplay: true,
      autoplaySpeed: 1000,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 1000,
    });

    waitForElementToExist('#faixa-cupom').then(element => {
      const faixCupom = document.querySelector('.faixa-cupom');
      if (faixCupom) {
        const formButton = document.querySelector('.faixa-cupom-form button');
        const spanElement = document.getElementById("valorParaCopiar");

        if (spanElement) {
          if (formButton) {
            formButton.addEventListener("click", (e) => {
              e.preventDefault();

              const range = document.createRange();
              range.selectNodeContents(spanElement);

              const selection = window.getSelection();
              selection.removeAllRanges();
              selection.addRange(range);

              try {
                const copied = document.execCommand("copy");
                selection.removeAllRanges();

                if (copied) {
                  alert("Valor copiado: " + spanElement.textContent);
                } else {
                  alert("Não foi possível copiar o texto.");
                }
              } catch (err) {
                console.error("Erro ao copiar: ", err);
                alert("Erro ao copiar o texto.");
              }
            });
          }
        }
      }
    });

    const stopwatchElement = document.querySelector('.stopwatch');

    if (stopwatchElement) {
      const urlParametro = stopwatchElement.getAttribute('data-url') ? stopwatchElement.getAttribute('data-url').trim() : "";
      const hora = parseInt(stopwatchElement.getAttribute('data-hour'));
      const dia = parseInt(stopwatchElement.getAttribute('data-day'));
      const mes = parseInt(stopwatchElement.getAttribute('data-month'));
      const ano = parseInt(stopwatchElement.getAttribute('data-year'));

      // Novos atributos de cor
      const backgroundColor = stopwatchElement.getAttribute('data-background-cronometro');
      const textColor = stopwatchElement.getAttribute('data-text-color-cronometro');

      if (!isNaN(hora) && !isNaN(dia) && !isNaN(mes) && !isNaN(ano)) {
        const urlAtual = window.location.pathname;
        let dataTermino;
        let cronometro;

        function formatarDigitos(numero) {
          const numeroFormatado = numero.toString().padStart(2, '0');
          return `
        <span style="
          background-color: ${backgroundColor};
          color: ${textColor};
        ">
          ${numeroFormatado[0]}
        </span>
        <span style="
          background-color: ${backgroundColor};
          color: ${textColor};
        ">
          ${numeroFormatado[1]}
        </span>
      `;
        }

        function atualizarCronometro() {
          const agora = new Date().getTime();
          const termino = dataTermino.getTime();
          const tempoRestante = termino - agora;

          if (tempoRestante >= 0) {
            const dias = Math.floor(tempoRestante / (1000 * 60 * 60 * 24));
            const horas = Math.floor((tempoRestante % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutos = Math.floor((tempoRestante % (1000 * 60 * 60)) / (1000 * 60));
            const segundos = Math.floor((tempoRestante % (1000 * 60)) / 1000);

            const diasFormatado = formatarDigitos(dias);
            const horasFormatado = formatarDigitos(horas);
            const minutosFormatado = formatarDigitos(minutos);
            const segundosFormatado = formatarDigitos(segundos);

            document.getElementById("cronometro").innerHTML = `
          <p>Termina em</p>
          <div>${diasFormatado}d ${horasFormatado}h ${minutosFormatado}m ${segundosFormatado}s</div>
        `;
          } else {
            document.getElementById("cronometro").innerHTML = "Tempo esgotado!";
            clearInterval(cronometro);
          }
        }

        function mostrarCronometro() {
          dataTermino = new Date(ano, mes - 1, dia, hora, 0);
          cronometro = setInterval(atualizarCronometro, 1000);
        }

        if (urlParametro === "" || urlAtual.includes(urlParametro)) {
          mostrarCronometro();
        } else {
          stopwatchElement.style.display = 'none';
        }

      } else {
        console.error('Os atributos data-hour, data-day, data-month ou data-year estão ausentes ou inválidos.');
      }

    } else {
      console.error('Elemento .stopwatch não encontrado.');
    }


    this.addPaddingHeader();
    this.scrollFixedMenu();

    window.addEventListener('scroll', this.handleScroll);

    let item1, item2, item3, item4

    if (document.getElementById('quick-item-1')) {
      item1 = document.getElementById('quick-item-1').getAttribute('item');
    }
    if (document.getElementById('quick-item-2')) {
      item2 = document.getElementById('quick-item-2').getAttribute('item');
    }
    if (document.getElementById('quick-item-3')) {
      item3 = document.getElementById('quick-item-3').getAttribute('item');
    }
    if (document.getElementById('quick-item-4')) {
      item4 = document.getElementById('quick-item-4').getAttribute('item');
    }

    if (item1 && item2 && item3 && item4) {
      this.filterItems(item1, item2, item3, item4);
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  watch: {
    cartOpened(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.removeProperty('overflow');
      }
    },

    searchOpened(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.removeProperty('overflow');
      }
    },
  }
});

const openSearch = document.querySelector('.open-search .open-search-icon');
const search = document.querySelector('.search');
if (openSearch && search) {
  openSearch.addEventListener('click', () => {
    openSearch.classList.toggle('active');
    search.classList.toggle('active');
  });
}

/* Mobile Wrapper */
const mobileNavLinks = document.querySelectorAll('.mobile-nav__link.ewrap');

mobileNavLinks.forEach(link => {
  link.addEventListener('click', function (event) {
    event.preventDefault();
    this.classList.toggle('active');
    const wrapper = this.nextElementSibling;
    if (wrapper && wrapper.tagName === 'UL') {
      wrapper.classList.toggle('active');
    }
  });
});

var cart_preview_triggers = $('.header__second--tools-cart, .cart-preview-close, .cart-preview-header__close, .btn-continue');

cart_preview_triggers.on("click", function (e) {
  if ($(window).width() >= 970) {
  };

  $('.cart-preview--overlay').toggleClass('active');
  $('.cart-preview').toggleClass('active');
  document.body.classList.toggle('no-scroll');
});

if (window.outerWidth > 991) {
  $(".header__cart__wrap").click(function (e) {
    e.preventDefault();
    $('.cart-preview').addClass('active');
    $('.cart-preview--overlay').addClass('active');
    document.body.classList.add('no-scroll');
  });

  $('.cart-preview--overlay').click(function (e) {
    e.preventDefault();
    $('.cart-preview').removeClass('active');
    $('.cart-preview--overlay').removeClass('active');
    document.body.classList.remove('no-scroll');
  })

  $('.cart-preview-header__close').click(function (e) {
    e.preventDefault();
    $('.cart-preview').removeClass('active');
    $('.cart-preview--overlay').removeClass('active');
    document.body.classList.remove('no-scroll');
  })
}